import styled from '@emotion/styled';
import Icons, { IIconsProps } from '@shared/components/core/images/Icons';
import { BodySmall, TitleSmall } from '@shared/components/core/text/Typography';
import { ICoreCardProps } from '@shared/models/components/ICoreCardProps';
import { CardSmall, WrapCardText } from './CommonCardStyles';

interface ICardCenteredContentProps extends IIconsProps, ICoreCardProps {}

const CardCenteredContent: React.FC<ICardCenteredContentProps> = ({
    title,
    description,
    name,
    size = 50,
    children,
    ...restProps
}) => {
    return (
        <CardSmall {...restProps}>
            <CenteredCardText>
                <Icons name={name} size={size} {...restProps} />
                <TitleSmall>{title}</TitleSmall>
                <BodySmall>{description}</BodySmall>
                {children}
            </CenteredCardText>
        </CardSmall>
    );
};

const CenteredCardText = styled(WrapCardText)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-grow: 1;
`;

export default CardCenteredContent;
